const dashboard = {
  addMultimedia: "Add Multimedia",
  planner: "Planner",
  basicInformation: "Basic Information",
  canYouConfirm: "Can you confirm that all the fields are correct?",
  checkFields: "Check Fields",
  dashboard: "Dashboard",
  datasheet: "Datasheet",
  documents: "Documents",
  assetList: "Assets",
  drawings: "Blueprints",
  eventManager: "Event Manager",
  eventTitleInspection: "New Inspection",
  eventTitleReliability: "RELIABILITY REPORT",
  eventMessage: {
    inspection: "There is a new inspection with a status",
    reliability: "There is a new reliability report with a status",
    and: "and"
  },
  graphics: "Graphics",
  inspections: "Inspections",
  manufacturer: "Manufacturer",
  meanTimeBetweenFailure: "Mean Time Between Failure",
  mechanicalAvailability: "Mechanical Availability",
  model: "Model",
  moreMeanTimeBetweenFailure:
    "This metric is the average length of operating time between failures for an asset or component.",
  moreMechanicalAvailability:
    "The percentage of time that the asset is capable of performing its intended function (uptime plus idle time).",
  moreOperatingTime:
    "An interval of time during which the asset or component is performing its required function.",
  moreTotalDowntime:
    " The amount of time an asset is not capable of running. The sum of  scheduled downtime and unscheduled downtime.",
  moreUtilizationTime:
    "Time when the asset is scheduled to run divided by total available time, expressed as a percentage.",
  operatingTime: "Operating Time",
  conditionMonitoringModule: "Condition Monitoring Module",
  mechanincalCondition: "Mechanincal Condition",
  mechanincalConditionOverTime: "Mechanincal Condition Over Time",
  ago: "ago",
  hours: "hours",
  hour: "hours",
  minutes: "minutes",
  seconds: "seconds",
  datepicker: {
    title: "Choose a date range",
    okbtn: "OK",
    cancelbtn: "CANCEL"
  },
  statuslights: {
    running: "Running",
    standby: "Standby",
    maintenance: "Maintenance",
    failure: "Failure"
  },
  buttons: {
    gotoEquipment: "Equipment"
  },
  messages: {
    unitRules: "Unit is required"
  },
  operationalValues: "Operational Values",
  ranges: "Ranges",
  reliability: "Reliability",
  reliabilityResume: "Reliability Resume",
  repairLog: "repair Log",
  equipmentDocs: "Equipment Documents",
  fileInput: "File Input",
  selectEquipmentsVariables: "Select equipment's variables",
  theLastReliability: "The Last Reliability Report was",
  totalDowntime: "Total Downtime",
  updateRanges: "Update Ranges",
  utilizationTime: "Utilization Time"
};
export default dashboard;
